import React, { useState } from 'react';

const Column = React.createContext({
  columns: [],
  setColumns: () => null,
});

export function ColumnProvider({ children, columns }) {
  const [cols, setCols] = useState(columns);

  return (
    <Column.Provider value={{ columns: cols, setColumns: setCols }}>
      {children}
    </Column.Provider>
  );
}

export default Column;
